<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
     v-dialogDrag
    :visible.sync="visible">
    <el-button v-if="method != 'add'" size="medium" class="mb8"  :icon="method == 'view' ? 'el-icon-edit' :''" :type="method == 'view' ? 'warning' :'primary'"  :plain="method == 'view' ? false : true"  @click="handEditorView(method)" :disabled="!hasPermission('about:cecAbout:edit')">{{ method == 'view' ? '编辑' : '取消'}}</el-button>
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  :gutter="15">
        <el-col :span="12">
            <el-form-item label="名称" prop="name"
                :rules="[
                  {required: true, message:'名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.name" placeholder="请填写名称"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="所属位置或栏目" prop="position"
                :rules="[
                  {required: true, message:'所属位置或栏目不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.position" placeholder="请填写所属位置或栏目"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="英文值" prop="valEn"
                :rules="[
                  {required: true, message:'英文值不能为空', trigger:'blur'}
                 ]">
          <el-input type="textarea" v-model="inputForm.valEn" placeholder="请填写英文值"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="中文值" prop="valCn"
                :rules="[
                 ]">
          <el-input type="textarea" v-model="inputForm.valCn" placeholder="请填写中文值"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="链接或路由" prop="url"
                :rules="[
                 ]">
              <el-input v-model="inputForm.url" placeholder="请填写链接或路由"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="图片" prop="pic"
                :rules="[
                 ]">
	          <image-upload v-model="inputForm.pic" :disabled="method === 'view'" :limit="3" tip="最多上传3个图片,单个图片不要超过10M"></image-upload>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" type="danger"  icon="el-icon-close" @click="visible = false">关闭</el-button>
      <el-button size="medium" type="success" icon="el-icon-check" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecAboutService from '@/api/about/cecAboutService'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          name: '',
          position: '',
          valEn: '',
          valCn: '',
          url: '',
          pic: ''
        }
      }
    },
    components: {
    },
    methods: {
      // 切换编辑状态
      handEditorView (method) {
        this.method = method === 'view' ? 'edit' : 'view'
      },
      init (method, id) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建about模块管理`
        } else if (method === 'edit') {
          this.title = '修改about模块管理'
        } else if (method === 'view') {
          this.title = '查看about模块管理'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecAboutService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecAboutService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>
<style scoped>
::v-deep .el-dialog__body{
 padding: 10px 20px !important;
}
</style>
  
